<template>
  <div id="app" :class="{ 'fix-ie': showLoader }">
    <div id="nprogress-container" />
    <ald-loader v-if="showLoader" :text="`${loaderText}...`" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SabadellRentingStaticPages',

  data() {
    return {
      errorConfig: {}
    };
  },

  computed: {
    showLoader() {
      return this.$store.getters['ui/dataUI']('loader');
    },

    loaderText() {
      return (
        this.$store.getters['ui/dataUI']('loaderText') || this.$t('message.generic.loadingData')
      );
    }
  },

  mounted() {
    this.setTheme(this.$store.getters['ui/dataUI']('theme'));

    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  }
};
</script>
